module.exports = __webpack_public_path__ + "img/parceiro3.d5877105.jpg";